(function(){
  const root=document.documentElement;
  root.classList.remove('no-js');

  const pageMap={
    '/pages/faq':'/pages/support#faq',
    '/pages/frequently-asked-questions':'/pages/support#faq',
    '/pages/certificates':'/#certificates',
    '/pages/coa':'/#certificates',
    '/pages/certificate-of-analysis':'/#certificates',
    '/pages/quality':'/#quality',
    '/pages/testing':'/#quality',
    '/pages/about':'/#about',
    '/pages/about-us':'/#about',
    '/pages/contact':'/pages/support#contact',
    '/pages/support':'/pages/support#contact',
    '/pages/shipping':'/pages/support#shipping',
    '/pages/shipping-policy':'/pages/support#shipping',
    '/pages/returns':'/pages/support#returns',
    '/pages/return-policy':'/pages/support#returns',
    '/pages/refund-policy':'/pages/support#returns',
    '/pages/wholesale':'/#wholesale',
    '/pages/research-use-agreement':'/#research-use',
    '/pages/disclaimer':'/#disclaimer',
    '/policies/terms-of-service':'/#terms',
    '/policies/privacy-policy':'/#privacy'
  };
  const normalizedPath=window.location.pathname.replace(/\/$/,'') || '/';
  if(document.body.dataset.template==='404' && pageMap[normalizedPath]){
    window.location.replace(pageMap[normalizedPath]);
    return;
  }

  const gate=document.querySelector('[data-age-gate]');
  const accepted=localStorage.getItem('805-age-accepted')==='true';
  if(gate && !accepted){gate.classList.add('is-open');document.body.classList.add('age-locked');}

  document.addEventListener('click',function(e){
    const accept=e.target.closest('[data-age-accept]');
    if(accept){localStorage.setItem('805-age-accepted','true');gate?.classList.remove('is-open');document.body.classList.remove('age-locked');}

    const decline=e.target.closest('[data-age-decline]');
    if(decline){window.location.href='https://www.google.com';}

    const menu=e.target.closest('[data-menu-toggle]');
    if(menu){
      const nav=document.querySelector('[data-nav]');
      nav?.classList.toggle('is-open');
      menu.setAttribute('aria-expanded',nav?.classList.contains('is-open') ? 'true' : 'false');
    }

    const navLink=e.target.closest('[data-nav] a');
    if(navLink){document.querySelector('[data-nav]')?.classList.remove('is-open');}
  });
})();
